import AntCarousel, { CarouselRef } from 'antd/lib/carousel'
import { useRef } from 'react'
import styled, { css } from 'styled-components'

import { TRANSITION_TIME_FAST_MS } from '../styles/mixins/constants'

import { Icon } from './Icon'

export type CarouselItem = {
    Slide: (() => JSX.Element) | JSX.Element
    key: string
    disabled?: boolean
}

type Props = {
    items: CarouselItem[]
    className?: string
    disableDots?: boolean
    onChange?: (currentSlide: number) => void
}

export const Carousel = (props: Props): JSX.Element => {
    const { items, onChange, className, disableDots } = props
    const ref = useRef<CarouselRef | null>(null)
    return (
        <Container className={className}>
            <AntCarousel ref={ref} dotPosition="bottom" beforeChange={onChange} dots={!disableDots}>
                {items.map(({ Slide, key }) =>
                    typeof Slide === 'function' ? <Slide key={key} /> : Slide
                )}
            </AntCarousel>
            <PreviousButton
                onClick={() => {
                    ref?.current?.prev()
                }}
            >
                <Icon iconKey="LeftChevron" size={6} color="inverted" />
            </PreviousButton>
            <NextButton
                onClick={() => {
                    ref?.current?.next()
                }}
            >
                <Icon iconKey="RightChevron" size={6} color="inverted" />
            </NextButton>
        </Container>
    )
}

const Container = styled.div`
    position: relative;

    .ant-carousel,
    .slick-slider,
    .slick-list,
    .slick-track,
    .slick-slide,
    .slick-slide > div {
        height: 100% !important;
    }
`

const BUTTON_STYLES = css`
    position: absolute;
    z-index: 10;
    height: 100%;
    display: flex;
    align-items: center;
    top: 0;
    background-color: rgba(0, 0, 0, 0.75);
    cursor: pointer;
    transition: background-color ${TRANSITION_TIME_FAST_MS}ms;
    &:hover {
        background-color: rgba(0, 0, 0, 0.5);
    }
    &:active {
        background-color: rgba(0, 0, 0, 0.75);
    }
`

const PreviousButton = styled.div`
    ${BUTTON_STYLES}
    left: 0;
`

const NextButton = styled.div`
    ${BUTTON_STYLES}
    right: 0;
`
